import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'rt-style-wrapper',
  styleUrl: 'style-wrapper.scss',
  shadow: false,
})
export class StyleWrapper {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
